module.exports = __webpack_public_path__ + "static/media/suoqili.14b3d6ba.png";